import { useContext } from 'react';
import { SearchModuleContext } from '../contexts';
export const useSearchModule = () => useContext(SearchModuleContext);
//# sourceMappingURL=useSearchModule.js.map